import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatDateTimeDisplayString } from "@/lib/string-utils";

interface ImagePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  imageUrl?: string | null;
  alt?: string;
  dateTaken?: string | null;
  createdByName?: string | null;
}

const ImagePreviewDialog: React.FC<ImagePreviewDialogProps> = ({
  open,
  onOpenChange,
  title,
  imageUrl,
  alt,
  dateTaken,
  createdByName,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] w-fit p-2 sm:p-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {imageUrl && (
          <div className="space-y-2">
            <img
              src={imageUrl}
              alt={alt ?? title}
              className="max-h-[85vh] max-w-[85vw] rounded-lg object-contain"
            />
            {dateTaken && (
              <p className="text-sm text-muted-foreground text-center">
                {formatDateTimeDisplayString(dateTaken)}
              </p>
            )}
            {createdByName && (
              <p className="text-sm text-muted-foreground text-center">
                Created by: {createdByName}
              </p>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
